import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureComparison from './components/FeatureComparison';
import FAQSection from './components/FAQSection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <FeatureComparison />
      <FAQSection />
      <BlogSection />
      <CTASection />
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'CSSBuySpreadsheet',
        url: 'https://cssbuyspreadsheet.team/',
        logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
        description: 'A planilha mais completa para comprar na China com CSSBuy. Economize até 60% em compras internacionais.',
        foundingDate: '2020',
        sameAs: [
          'https://kaspreadsheet.com'
        ]
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'CSSBuySpreadsheet',
        url: 'https://cssbuyspreadsheet.team/',
        description: 'Descubra as melhores planilhas CSSBuy atualizadas em 2026. Organize suas compras internacionais e economize até 60%.',
        inLanguage: 'pt-BR',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://cssbuyspreadsheet.team/?q={search_term_string}',
          'query-input': 'required name=search_term_string'
        }
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'O que é cssbuyspreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'CSSBuySpreadsheet é uma planilha completa e organizada que reúne os melhores produtos disponíveis na plataforma CSSBuy. Nossa planilha é atualizada regularmente com itens verificados, reviews positivos e preços competitivos.'
            }
          },
          {
            '@type': 'Question',
            name: 'CSSBuy spreadsheet é confiável?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sim, absolutamente. Nossa planilha CSSBuy é construída por especialistas que utilizam a plataforma há anos. Cada produto listado passa por verificação de qualidade e análise de reviews antes de ser incluído.'
            }
          },
          {
            '@type': 'Question',
            name: 'Como usar planilhas CSSBuy?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Usar o cssbuyspreadsheet é muito simples. Basta acessar a categoria desejada através dos links em nossa página, encontrar o produto que mais combina com seu estilo, copiar o link e colar na plataforma CSSBuy para finalizar sua compra.'
            }
          },
          {
            '@type': 'Question',
            name: 'Qual melhor spreadsheet CSSBuy 2026?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'O cssbuyspreadsheet é considerado a melhor planilha CSSBuy de 2026 por diversos motivos: atualização constante, verificação rigorosa de qualidade, cobertura completa de categorias e uma comunidade ativa. Nossa taxa de satisfação é superior a 95%.'
            }
          },
          {
            '@type': 'Question',
            name: 'Quanto posso economizar com cssbuyspreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Usuários do cssbuyspreadsheet relatam economia média de 40% a 60% em comparação com compras diretas. Nossa planilha identifica os melhores preços, promoções ativas e fornecedores com melhor custo-benefício.'
            }
          },
          {
            '@type': 'Question',
            name: 'A planilha é atualizada com que frequência?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Nossa equipe atualiza o cssbuyspreadsheet semanalmente, garantindo que todos os links estejam ativos, os preços estejam corretos e novos produtos de qualidade sejam adicionados regularmente.'
            }
          }
        ]
      }) }} />
    </main>
  );
}